import type { ValidatedApiClient } from '../types/api-client';
import { type AccessTokenRequest, accessTokenResponseSchema } from './schema';

export const AUTH_TOKEN_API_PATH = '/auth/token';

const toFormBody = (request: AccessTokenRequest): URLSearchParams => {
    const body = new URLSearchParams();
    for (const [key, value] of Object.entries(request)) {
        if (value !== undefined) {
            body.set(key, value);
        }
    }
    return body;
};

export const createAuthApi = ({ validatedFetch }: ValidatedApiClient) => ({
    /** Errors carry the body's `hint` (`email` when sign-up fails because the address is taken). */
    requestAccessToken: (request: AccessTokenRequest) =>
        validatedFetch(accessTokenResponseSchema, AUTH_TOKEN_API_PATH, new URLSearchParams(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: toFormBody(request),
        }),
});

export type AuthApi = ReturnType<typeof createAuthApi>;
